// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-link {
  border-radius: 2px;
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
  cursor: pointer;
  outline: transparent;
  text-decoration: underline;
  transition: color 80ms cubic-bezier(0.165, 0.84, 0.44, 1), background 80ms linear;
}
.bolt-link:hover {
  color: rgba( 0, 69, 120 ,  1 );
  color: rgba( var(--palette-primary-shade-30,0, 69, 120) ,  1 );
}
.bolt-focus-visible .bolt-link:focus {
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-link:focus {
    animation: none;
  }
}
.bolt-focus-visible .bolt-link:focus {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-link.subtle {
  border-radius: 4px;
  color: inherit;
  padding: 3px 6px;
}
.bolt-link.subtle:hover {
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
  background-color: unset;
}
.bolt-link.disabled {
  cursor: default;
}
.bolt-link.underline {
  text-decoration: underline;
}

.bolt-focus-visible .bolt-link.subtle:focus {
  background-color: unset;
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
  outline: none;
}
.bolt-focus-visible .bolt-link:focus {
  text-decoration: none !important;
  color: rgba( 0, 69, 120 ,  1 );
  color: rgba( var(--palette-primary-shade-30,0, 69, 120) ,  1 );
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-link:focus {
    outline: 1px solid highlight !important;
  }
}

.bolt-link.no-underline-link {
  text-decoration: none !important;
}
.bolt-link.no-underline-link:hover {
  background-color: rgba(0, 0, 0, 0.06);
  background-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}

/*# sourceMappingURL=Link.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Link/Link.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Link/Link.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,0BCcuB;EDbvB,0DAAA;EACA,eAAA;EACA,oBAAA;EACA,0BAAA;EEHF,iFAAiF;AFK/E;AEHJ;EACE,8BAA8B;EFOxB,8DAAA;AELR;AACA;ECkCI,oEAAA;ADhCJ;AACA;EACE;IACE,eAAe;EFDX;AEGR;AACA;EFCI,6EAAA;EACI,oIAAA;AECR;AACA;EACE,kBAAkB;EFCZ,cAAA;EACI,gBCRe;ACS3B;AACA;EFGI,0BAAA;EACI,0DAAA;EEDN,uBAAuB;AFIrB;AEFJ;EACE,eAAe;AACjB;AFMI;EACI,0BAAA;AEJR;;AAEA;EFOI,uBAAA;EACI,0BAAA;EACA,0DC3CiB;ECsCvB,aAAa;ACCX;ADCJ;EACE,gCFIU;EEHV,8BAA8B;EAC9B,8DAA8D;AAChE;AFMA;EACI;IEJA,uCAAuC;EFKvC;AEHJ;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,kEAAkE;AACpE;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
